/* global $ */

class Marquee {
  constructor($el) {
    this.id = this.getRandomId();
    this.$window = $(window);
    this.$el = $el;
    this.$text = this.$el.children('.Marquee__content');
    this.textPos = 0;
    this.isEdgeObject = false;
    if (this.$el.offset()['left'] == 0) {
      this.isEdgeObject = true;
    }

    this.$window.on('resize.' + this.id, () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  getRandomId() {
    let c = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let cl = c.length;
    let r = '';
    for (var i = 0; i < 8; i++) {
      r += c[Math.floor(Math.random() * cl)];
    }
    return r;
  }

  start() {
    clearTimeout(this.startTimeout);
    clearInterval(this.updateInterval);
    this.$el.removeClass('Marquee--no-slide');
    this.startTimeout = setTimeout(() => {
      this.updateInterval = setInterval(() => {
        this.update();
      }, 1000 / 30);
    }, 3000);
    if (this.isEdgeObject) {
      this.$el.css('padding-left', 0);
    }
  }
  stop() {
    this.$el.addClass('Marquee--no-slide');
    clearTimeout(this.startTimeout);
    clearInterval(this.updateInterval);
    this.textPos = 0;
    this.$text.css('transform', `translateX(${this.textPos}px)`);
    if (this.isEdgeObject) {
      this.$el.css('padding-left', 20);
    }
  }
  update() {
    this.textPos -= 2;
    if (this.textPos <= -this.textWidth) {
      this.textPos = this.containerWidth;
    }
    this.$text.css('transform', `translateX(${this.textPos}px)`);
  }

  onWindowResize() {
    clearTimeout(this.startTimeout);
    clearInterval(this.updateInterval);
    this.containerWidth = this.$el.outerWidth();
    this.textWidth = parseInt(this.$text.width());

    this.textPos = 0;
    this.$text.css('transform', `translateX(${this.textPos}px)`);

    // テキストが見切れていなくても、Marquee を実行 #81
    this.start();

    // 以前の処理
    // if (this.textWidth > this.containerWidth) {
    // this.start();
    // } else {
    //   this.stop();
    // }
  }

  destroy() {
    clearTimeout(this.startTimeout);
    clearInterval(this.updateInterval);
    this.$window.off('.' + this.id);
  }
}

export default Marquee;
